import { faPdfFile } from '@awesome.me/kit-379289146f/icons/kit/custom';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  IconButton,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from '@mui/material';
import { useBoolean } from 'usehooks-ts';

import { ActionTooltip } from '@/components';
import { useUserInfo } from '@/features/users';

import DownloadIcon from '../assets/download.svg?react';
import { useInvoices } from '../hooks';
import { formatDate } from '../utils';

import { Section } from './layout/Section';

export const Invoices = () => {
  const theme = useTheme();
  const { company_id } = useUserInfo();
  const { data: invoices = [], isFetching } = useInvoices(company_id);

  const { value: isCollapsed, toggle: toggleIsCollapsed } = useBoolean(true);

  const handleSimpleDownload = (pdfUrl: string) => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderContent = () => {
    if (isFetching)
      return (
        <>
          {Array.from({ length: 5 }).map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Stack direction={'row'} alignItems={'center'} spacing={2}>
                  <Skeleton variant="rounded" width={32} height={32} />
                  <Skeleton variant="text" width={250} height={24} />
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </>
      );

    if (Array.isArray(invoices) && invoices.length > 0)
      return (
        <>
          {Array.isArray(invoices) &&
            invoices?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Stack
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                  >
                    <Stack direction={'row'} alignItems={'center'} spacing={2}>
                      <FontAwesomeIcon
                        icon={faPdfFile as IconProp}
                        size="xl"
                        color={theme.palette.primary.dark}
                      />
                      <Box>{formatDate(item.invoice_date)}</Box>
                    </Stack>
                    <ActionTooltip title="Download">
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleSimpleDownload(item.invoice_pdf);
                        }}
                      >
                        <DownloadIcon />
                      </IconButton>
                    </ActionTooltip>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
        </>
      );

    return (
      <TableRow>
        <TableCell>No invoice available</TableCell>
      </TableRow>
    );
  };

  return (
    <Section
      title={'Invoices'}
      isCollapsed={isCollapsed}
      toggleIsCollapsed={toggleIsCollapsed}
    >
      <Stack pt={2}>
        <TableContainer>
          <Table stickyHeader>
            <TableBody>{renderContent()}</TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Section>
  );
};
